import { Button, Col, Modal, Row } from 'react-bootstrap'
import { useState } from 'react';
import Regular from './eventTypes/Regular';
import Poll from './eventTypes/Poll';
// import other event type components as needed

export default function AgendaItemModal({ agenda, item, getMeeting }) {

  const [currentIndex, setCurrentIndex] = useState(
    agenda.findIndex(agendaItem => agendaItem.agendaItemId === item.agendaItemId)
  );

  const currentItem = agenda[currentIndex];

  const [showModal, setShowModal] = useState(false)
  const [isPlaying, setIsPlaying] = useState(false);

  const handleCloseModal = () => setShowModal(false)
  const handleShowModal = () => {
    const newIndex = agenda.findIndex(agendaItem => agendaItem.agendaItemId === item.agendaItemId);
    setCurrentIndex(newIndex);
    setShowModal(true);
  };

  const handleNextItem = () => {
    if (currentIndex < agenda.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePreviousItem = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  // Switch logic for event type
  const renderEventComponent = () => {
    switch (currentItem?.agendaEvent?.eventType) {
      case 'regular':
        return (
          <Regular
            item={currentItem}
            getMeeting={getMeeting}
            isPlaying={isPlaying}
            setIsPlaying={setIsPlaying}
          />
        );
      case 'poll':
        return (
          <Poll
            agenda={agenda}
            item={currentItem}
          // Add any other props needed for Poll
          />
        );
      // Add more cases for other event types and their components
      default:
        return (
          <Regular
            item={currentItem}
            getMeeting={getMeeting}
            isPlaying={isPlaying}
            setIsPlaying={setIsPlaying}
          />
        );
    }
  };

  return (
    <>
      <Button variant="link" onClick={handleShowModal} style={{ padding: 0, border: 'none', background: 'none' }} className='me-4 float-end' >
        <i className='bi bi-display' style={{ fontSize: '25px', color: 'white' }}></i>
      </Button>

      <Modal
        centered
        show={showModal}
        onHide={handleCloseModal}
        className='text-center'
        data-bs-theme={'dark'}
        fullscreen
      >
        <Modal.Header className='timer-header'>
          <Row>
            <Col>
              <h2 className='text-inline'> {currentItem?.meetingTheme}  </h2>
            </Col>
          </Row>
        </Modal.Header>

        {renderEventComponent()}

        {!isPlaying && (
          <Modal.Footer className="d-flex justify-content-between">
            <>
              <div style={{ justifyContent: 'flex-start' }} className='float-start'>
                <Button
                  onClick={handlePreviousItem}
                  disabled={currentIndex === 0}
                  className="me-2"
                >
                  Previous
                </Button>
                <Button
                  onClick={handleNextItem}
                  disabled={currentIndex === agenda.length - 1}
                >
                  Next
                </Button>
              </div>
              <div style={{ justifyContent: 'flex-end' }} className='float-end'>
                <Button variant='success' onClick={handleCloseModal}>
                  Close
                </Button>
              </div>
            </>
          </Modal.Footer>
        )}
      </Modal>
    </>
  )
}